import React from 'react';
import { Box } from '@mantine/core';

interface PageContainerProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

/**
 * Contenedor estándar de página interna: ancho completo y padding consistente
 * (16px 24px), igual que Dashboard/Estadísticas. Garantiza que el título quede
 * SIEMPRE en la misma posición arriba-izquierda en todas las vistas.
 */
const PageContainer: React.FC<PageContainerProps> = ({ children, style }) => (
  <Box style={{ padding: '16px 24px', width: '100%', ...style }}>
    {children}
  </Box>
);

export default PageContainer;
